<template>
  <div class="myrepair">
    <div class="page-search search-btns">
      <div class="xzcontent"></div>
      <a-button style="display: block;margin: 0 auto;" type="primary" @click="toApply">我要报修</a-button>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
export default {
  name: 'RepairList',
  data () {
    return {
      ny: ''
    }
  },
  beforeMount () {
    // 报修须知内容
    this.xzcontent()
  },
  methods: {
    // 我要报修
    toApply () {
      let routeuil = this.$router.resolve({
        path: '/apply',
        query: { bxtype: 2 }
      })
      window.open(routeuil.href, '_blank')
    },
    // 报修须知内容
    xzcontent () {
      this.$axios.post('/api/bxjl/getBxxz.do').then(res => {
        if (res.flag) {
          if (res.data.data !== null) {
            this.ny = res.data.data.ny
            if (res.data.data.ny === '') {
              this.ny = '尚未编辑须知内容'
            }
          }
        }
        this.$nextTick(() => {
          setTimeout(() => {
            $('.xzcontent').html(this.ny)
          }, 200);
        })
      })
    },
  }
}
</script>
<style>
.myrepair .ant-layout-content .page-search {
  border-bottom: none;
}
.myrepair .xzcontent {
  width: 800px;
  margin: 0 auto;
}
.myrepair .xzcontent p {
  text-indent: 0;
}
</style>
